import React from 'react'
import { Helmet } from 'react-helmet'
import SecondaryHeader from '../masterLayout/SecondaryHeader'

const Members = () => {
 return (
  <React.Fragment>
   <Helmet>
    {' '}
    <title>Members</title>{' '}
   </Helmet>
   <SecondaryHeader
    page_title="Members"
    banner={require('../assets/images/members/banner.jpg')}
   />
   <div className="sectionWrap">
    <div className="sectionContainer">
     <div className="members-page">
      <section className="intro-copy">
       <h3>A New Path to Better Care</h3>
       <p>
        You didn’t choose the condition.
        <br />
        But you can choose how you care for yourself.
       </p>
       <div className="body-copy">
        <p>
         For too long, patients have been handed prescriptions that manage
         symptoms.
         <br />
         These options come with harsh side effects, dependency risks, and a
         loss of control.
         <br />
         That’s not care. That’s compromise.
        </p>
       </div>
      </section>

      <section className="highlight-band">
       <p>At Bennabix, we believe in something better:</p>
       <h4>Compassionate, personalized care with medical cannabis.</h4>
      </section>

      <section className="two-col about-alt">
       <div className="col text">
        <p>
         Whether you're managing chronic pain, anxiety, insomnia, cancer
         symptoms, or any qualifying condition, medical cannabis may offer a
         gentler, more effective alternative.
        </p>
        <p>
         Not a cure–all, but a natural alternative to help you sleep better,
         move easier, breathe deeper, and feel more like yourself again.
        </p>
        <p className="strong">And you don’t have to figure it out alone.</p>
       </div>
       <div className="col media">
        <img
         src={require('../assets/images/members/couple-bike.jpg')}
         alt="Couple biking"
        />
       </div>
      </section>

      <section className="two-col two-col__alt with-divider">
       <div className="col media">
        <img
         src={require('../assets/images/members/doctor_photo.jpg')}
         alt="Doctor consulting patient"
        />
       </div>
       <div className="col card">
        <div className="card-body">
         <p>
          We connect you with licensed medical professionals, simplify your
          enrollment, and ensure you get real savings, so that access is never
          out of reach.
         </p>
         <p>
          At Bennabix, our mission is simple: to normalize medical cannabis in
          healthcare as a respected therapeutic choice and to support those
          ready to explore its potential.
         </p>
         <ul>
          <li>To provide options that work.</li>
          <li>To support outcomes that matter.</li>
          <li>To help people live well, with less pain and more peace.</li>
         </ul>
        </div>
       </div>
      </section>
      <section className="is-medical-cannabis-right-for-you">
       <h5>Is medical cannabis right for you?</h5>
       <p>
        If you are considering medical marijuana and don't have a card yet, find
        out if you have a condition that qualifies you for a cannabis card in
        your state here.
       </p>
      </section>

      <section className="cta-row">
       <div className="cta-text">
        <h4>Get the power of medical cannabis — </h4>
        <button
         className="btn-primary"
         onClick={() => (window.location.href = '/enroll')}
        >
         Enroll Today!
        </button>
       </div>
       <div className="cta-badge">
        <img
         src={require('../assets/images/members/premium_member_badge.jpg')}
         alt="Premium member badge"
        />
       </div>
      </section>

      <section className="benefits-list">
       <h5>Your Bennabix Premium Membership includes:</h5>
       <ul className="benefit-items">
        <li>
         <div className="icon">
          <img src={require('../assets/images/benefit-professionals/Dr-Icon.png')} alt="Medical care icon" />
         </div>
         <div className="copy">
          <h6>Access to qualified medical cannabis care</h6>
          <p>
           guided by licensed professionals, personalized for individual needs.
          </p>
         </div>
        </li>
        <li>
         <div className="icon">
          <img src={require('../assets/images/benefit-professionals/Flower-Icon.png')} alt="Savings icon" />
         </div>
         <div className="copy">
          <h6>Savings up to 30% through a dispensary network</h6>
          <p>
           making effective treatment more affordable and accessible.{' '}
           <small>*Exclusions apply.</small>
          </p>
         </div>
        </li>
        <li>
         <div className="icon">
          <img src={require('../assets/images/benefit-professionals/Head-Icon.png')} alt="Education icon" />
         </div>
         <div className="copy">
          <h6>Education and support</h6>
          <p>facilitating informed decisions with confidence and compassion.</p>
         </div>
        </li>
        <li>
         <div className="icon">
          <img src={require('../assets/images/benefit-professionals/Stethescope2-Icon.png')} alt="Outcomes icon" />
         </div>
         <div className="copy">
          <h6>Better outcomes</h6>
          <p>
           naturally improving quality of life while reducing reliance on
           pharmaceuticals with harsh side effects.
          </p>
         </div>
        </li>
       </ul>
       <div className="benefits-cta">
        <button
         className="btn-primary"
         onClick={() => (window.location.href = '/enroll')}
        >
         Enroll Today!
        </button>
       </div>
      </section>
      <section className="exclusions">
       <h5>*Exclusions:</h5>
       <p>
        Medical cannabis card is required. Our partners offer discounts on
        telehealth appointments for certification.
       </p>
       <p>
        Available in DE, ME, MD, MA, NJ, NM, NY and DC. Check back as we
        continue to add new states and dispensary locations.
       </p>
       <p>
        <strong>Discount:</strong> The discount amount varies by dispensary,
        typically 15% off.
       </p>
       <p>
        <strong>Discount Stacking:</strong> Not all dispensaries allow stacking.
        When allowed, there is a maximum discount of 30%.
       </p>
       <p>
        <strong>Exclusions:</strong> Some promotions and specials are not
        eligible for our discount or stacking. Due to market volatility and
        price compression, there may be changes to what promotions are eligible
        for stacking from time to time. Paraphernalia such as glass and vapes
        are not eligible to be discounted.
       </p>
       <p>
        Enroll and pay online via credit card - Visa, Mastercard, American
        Express or Discover.
       </p>
       <p>
        We also offer group health benefits for covered medical cannabis
        programs, ask your employer about offering Bennabix.
       </p>
      </section>
     </div>
    </div>
   </div>
  </React.Fragment>
 )
}

export default Members
